import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { Subscription, filter } from 'rxjs';
import { SystemNotificationService } from '../../services/system-notification.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { SystemNotificationsTypeEnum } from '../../enums/system-notifications-type.enum';
import { SystemNotificationModel } from '../../models/system-notification.model';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { SystemsNotificationsCreateDialogComponent } from '../SystemsNotificationsCreateDialog/systems-notifications-create-dialog.component';
import { TimeZoneFormatEnum } from '../../../../Common/Misc/enums/time-zone-format.enum';
import { SystemNotificationsStatusEnum } from '../../enums/system-notifications-status.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { MessageService } from 'primeng/api';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { MessageIconTypesEnum } from '../../../../Common/Misc/components/Message/message.component';

@Component({
    selector: 'agpr-systems-notifications-card',
    templateUrl: './systems-notifications-card.component.html',
    styleUrls: ['./systems-notifications-card.component.scss'],
    standalone: false
})
export class SystemsNotificationsCardComponent implements OnInit, OnDestroy {
    readonly systemNotificationTypesEnum = SystemNotificationsTypeEnum;
    readonly systemNotificationStatusEnum = SystemNotificationsStatusEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly iconTypes = MessageIconTypesEnum;
    focused: boolean = false;
    selected: boolean = false;
    subscriptions: Subscription[] = [];
    preferences: PreferencesModel;
    defaultTimeFormat: string;

    @Input() id: string;
    @Input() notification: SystemNotificationModel;
    @Input() selectedNotifications: SystemNotificationModel[];
    @Output() cardsSelected: EventEmitter<SystemNotificationModel[]> = new EventEmitter();
    constructor(
        private systemNotificationService: SystemNotificationService,
        private currentUserStateService: CurrentUserStateService,
        private coreDialogService: CoreDialogService,
        private messageService: MessageService,
        private localizationService: LocalizationService
    ) {

    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs =>{
                this.preferences = prefs;
                this.defaultTimeFormat = this.preferences.getDateFormatString(true, true, true);
            }),
            this.systemNotificationService.getFocusedNotification().subscribe(focusedItem => {
                if (focusedItem) {
                    this.focused = focusedItem.id === this.notification.id;
                }
            })
        );
    }
    cardFocused() {
        this.systemNotificationService.setFocusedNotification(this.notification);
    }

    deleteCard() {
        this.systemNotificationService.deleteNotifications([this.notification]);
    }

    cardSelected() {
        this.selected = this.selectedNotifications.includes(this.notification);
        this.cardsSelected.emit(this.selectedNotifications);
    }

    editNotification(stopNow?: boolean) {
        if (stopNow) {
            this.notification.notificationTimeRange.end = new Date();
            this.systemNotificationService.updateNotification(this.notification).subscribe({
                next: () => {
                    this.messageService.add({
                        severity: messageSeverityEnum.success,
                        summary: 'SystemNotification.update.success.heading',
                        detail: this.localizationService.transform('SystemNotification.update.success.message', { name: this.notification.title }),
                    });
                    this.systemNotificationService.reloadList();
                },
                error: () => {
                    this.messageService.add({
                        severity: messageSeverityEnum.error,
                        summary: 'SystemNotification.update.error.heading',
                        detail: this.localizationService.transform('SystemNotification.update.error.message', { name: this.notification.title }),
                    });
                }
            });
        } else {
            this.coreDialogService.open(SystemsNotificationsCreateDialogComponent, {
                inputs: {
                    notification: this.notification.clone()
                }
            });
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
